import i18n from 'i18n-js';

import { WordGuessingLogo, WordGuessingSimple } from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const WORDGUESSING_COMPONENTS = {
  [TEMPLATES_TITLES.WORDGUESSING_LOGO]: WordGuessingLogo,
  [TEMPLATES_TITLES.WORDGUESSING_SIMPLE]: WordGuessingSimple,
};

export const WORDGUESSING_DESIGNS_DATA = {
  [TEMPLATES_TITLES.WORDGUESSING_LOGO]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.cardUnrevealed'),
          value: 'card',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.cardRevealed'),
          value: 'reveal',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 10,
              type: 'slider',
              value: 'size',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 302,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 303,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.WORDGUESSING_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.cardUnrevealed'),
          value: 'card',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.cardRevealed'),
          value: 'reveal',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 10,
              type: 'slider',
              value: 'size',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 302,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 303,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
};

export default {
  WORDGUESSING_COMPONENTS,
  WORDGUESSING_DESIGNS_DATA,
};
